import { UnifiedSearch } from '@/components/shared/UnifiedSearch';
import { Button } from '@/components/ui/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { cn } from '@/lib/utils';
import { ArrowDownAZ, ArrowUpAZ, ArrowUpDown, Filter } from 'lucide-react';
import React from 'react';

interface ThoughtsToolbarProps {
    activeTab: 'all' | 'favorites';
    onTabChange: (tab: 'all' | 'favorites') => void;
    sortOrder: 'newest' | 'oldest';
    onSortChange: (sort: 'newest' | 'oldest') => void;
    searchQuery?: string;
    onSearchChange?: (query: string) => void;
    className?: string;
}

export const ThoughtsToolbar: React.FC<ThoughtsToolbarProps> = ({
    activeTab,
    onTabChange,
    sortOrder,
    onSortChange,
    searchQuery,
    onSearchChange,
    className
}) => {
    return (
        <div className={cn("flex flex-col sm:flex-row items-center justify-between gap-4 w-full", className)}>
            <div className="flex items-center gap-4 w-full sm:w-auto flex-1">
                {onSearchChange && (
                    <UnifiedSearch
                        placeholder="Search thoughts..."
                        value={searchQuery || ''}
                        onChange={(val) => onSearchChange(val)}
                        className="w-full sm:w-[320px]"
                        shortcut={true}
                    />
                )}
            </div>

            <div className="flex items-center gap-2">
                {/* Filter Dropdown */}
                <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                        <Button variant="ghost" size="sm" className="h-9 px-3 text-muted-foreground hover:text-foreground">
                            <Filter className="h-4 w-4 mr-2" />
                            <span className="text-xs font-medium">
                                {activeTab === 'favorites' ? 'Favorites' : 'All Thoughts'}
                            </span>
                        </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="end">
                        <DropdownMenuItem onClick={() => onTabChange('all')}>
                            All Thoughts
                        </DropdownMenuItem>
                        <DropdownMenuItem onClick={() => onTabChange('favorites')}>
                            Favorites
                        </DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>

                {/* Sort Dropdown */}
                <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                        <Button variant="ghost" size="sm" className="h-9 px-3 text-muted-foreground hover:text-foreground">
                            <ArrowUpDown className="h-4 w-4 mr-2" />
                            <span className="text-xs font-medium">
                                {sortOrder === 'newest' ? 'Newest' : 'Oldest'}
                            </span>
                        </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="end">
                        <DropdownMenuItem onClick={() => onSortChange('newest')}>
                            <ArrowUpAZ className="h-4 w-4 mr-2" />
                            Newest First
                        </DropdownMenuItem>
                        <DropdownMenuItem onClick={() => onSortChange('oldest')}>
                            <ArrowDownAZ className="h-4 w-4 mr-2" />
                            Oldest First
                        </DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
            </div>
        </div>
    );
};
